export const MILLISECONDS_IN_A_SEC = 1000;
export const DELAY_ON_RESOLVED = 2;
export const DELAY_ON_NOT_RESOLVED = 10;
